import { create, LogLevel } from '@thoughtspot/logger';
import { onMessage } from 'promise-postmessage';
const logger = create('ChartAppEventBridge');
export const registerChartComponent = (el, componentId, dispatcherCB) => {
    return onMessage(dispatcherCB, el, 'parent');
};
logger.setLogLevel(LogLevel.DEBUG);
//# sourceMappingURL=chart-app-event-bridge.js.map